import { IColumns } from '../../../../components/Table'

export type ClientTypesColumnsType = 'name' | 'assets' | 'actions'

export const columns: IColumns<ClientTypesColumnsType>[] = [
  {
    id: 'name',
    label: 'NAME',
  },
  {
    id: 'assets',
    label: 'ASSETS',
    format: (value) => (value as string[]).join(', '),
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
